import customAxios from '../interceptors';

const getUsers = () => {
  return customAxios.get(`${process.env.REACT_APP_API_URL}/users`);
}

export default getUsers;
